/**
 * D-274 §1 — the <option>s of a native <select>: rows without a `group` as
 * they are, each run of rows with the same `group` inside one <optgroup>
 * (so "עבודה פנימית OTE" stands apart from the "לקוחות" under it). Without
 * any `group` it renders exactly the plain <option> list it replaces.
 */
import type { ReactElement } from 'react';

export interface GroupedOption {
  value: string;
  label: string;
  group?: string;
  disabled?: boolean;
}

export default function GroupedOptions({ options }: { options: readonly GroupedOption[] }) {
  const out: ReactElement[] = [];
  let i = 0;
  while (i < options.length) {
    const o = options[i];
    if (!o.group) {
      out.push(<option key={`o-${o.value}`} value={o.value} disabled={o.disabled}>{o.label}</option>);
      i++;
      continue;
    }
    const run: GroupedOption[] = [];
    const g = o.group;
    while (i < options.length && options[i].group === g) run.push(options[i++]);
    out.push(
      <optgroup key={`g-${g}-${i}`} label={g}>
        {run.map((r) => <option key={`o-${r.value}`} value={r.value} disabled={r.disabled}>{r.label}</option>)}
      </optgroup>,
    );
  }
  return <>{out}</>;
}
